import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import Colors from 'constants/colors';
import FontStyles from 'constants/font-styles';
import Image from 'components/common/Image';
import icArrowBkPC1x from 'assets/images/PC/@1x/ic_arrow_bk.png';
import icArrowBkPC2x from 'assets/images/PC/@2x/ic_arrow_bk@2x.png';
import icArrowBkSP2x from 'assets/images/SP/@2x/ic_arrow_bk_1@2x.png';
import icArrowBkSP3x from 'assets/images/SP/@3x/ic_arrow_bk_1@3x.png';

const Steps = ({ className, steps }) => (
  <div className={className}>
    <ul className="steps">
      {steps.map((item, i) => (
        <li key={i}>
          {item.p ? (
            <React.Fragment>
              <Image
                pc1x={item.img.pc1x}
                pc2x={item.img.pc2x}
                sp2x={item.img.sp2x}
                sp3x={item.img.sp3x}
                alt={item.img.alt}
              />
              <p>
                {item.p.map((p, j) => (
                  <span key={`${i}${j}`}>
                    {p.tip ? (
                      <span
                        className="tips"
                        dangerouslySetInnerHTML={{ __html: p.tip }}
                      />
                    ) : (
                      <span dangerouslySetInnerHTML={{ __html: p.label }} />
                    )}
                  </span>
                ))}
              </p>
            </React.Fragment>
          ) : (
            <Image
              pc1x={icArrowBkPC1x}
              pc2x={icArrowBkPC2x}
              sp2x={icArrowBkSP2x}
              sp3x={icArrowBkSP3x}
              alt="ic_arrow_bk"
            />
          )}
        </li>
      ))}
    </ul>
  </div>
);

const commonStyle = css`
  ul.steps {
    margin: 0 auto;
    list-style: none;
    padding: 0;
    font-size: 0;

    li {
      p {
        color: ${Colors.black1};

        .tips {
          display: block;
        }
      }
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  ul.steps {
    overflow: hidden;
    display: flex;
    justify-content: center;

    li {
      float: left
      text-align: center;

      &:nth-of-type(even) {
        padding:112px 16px;
      }

      p {
        margin-top: 11px;
        ${FontStyles.text7};

        .tips {
          ${FontStyles.text10};

          padding-top: 9px;
        }
      }
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  ul.steps {
    li {
      clear: both;
      display: inline-block;
      width: 100%;
      position: relative;

      &:nth-of-type(odd) {
        p,
        img {
          float: left;
        }

        p {
          position: absolute;
          margin: 0;
          padding: 0 0 0 16px;
          ${FontStyles.text5};
          left: 50%
          top: 50%;
          transform: translate(0, -50%);

          .tips {
            ${FontStyles.text8};
            padding-top: 6px;
            padding-left: 1.25em;
            text-indent: -1.25em;
          }
        }
      }

      &:nth-of-type(even) {
        padding: 16px 0;
        width: 160px;
        text-align: center;
      }
    }
  }
`;

export default applyStyles(Steps)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/About/Gift/components/Steps.js